import { Row, Col, Modal, Button } from 'antd';
import React, { useState } from 'react';

/**
 * Product Settings Archive Component
 *
 * @typedef {{ onClick: () => Promise<void> }} ArchiveProps
 * @type {React.FC<ArchiveProps>}
 */
const Archive = ({ onClick }) => {
  const [modal, setModal] = useState({
    show: false,
  });
  const [submitting, setSubmitting] = useState(false);

  async function handleConfirm() {
    setSubmitting(true);
    await onClick();
    setModal(x => ({ ...x, show: false }));
    setSubmitting(false);
  }

  return (
    <>
      <Button
        key="archive-listing"
        onClick={() => setModal(x => ({ ...x, show: true }))}
        className="trend-btn secondary"
        style={{ borderColor: '#a9b0b9' }}
      >
        Archive
        <span className="hidden-xmobile">&nbsp;Campaign</span>
      </Button>
      <Modal
        visible={modal.show}
        onCancel={() => setModal(x => ({ ...x, show: false }))}
        className="trend-modal"
        closable={false}
        footer={null}
        width={350}
      >
        <div className="label">
          Are you sure you want to
          <div className="highlighted">archive this campaign?</div>
        </div>

        <Row style={{ marginTop: '20px' }} gutter={20} key="reject-modal">
          <Col span={12}>
            <Button
              key="cancel"
              disabled={submitting}
              onClick={() => setModal(x => ({ ...x, show: false }))}
              className="trend-btn medium-btn secondary"
              block
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              key="submit"
              loading={submitting}
              onClick={handleConfirm}
              className="trend-btn medium-btn"
              block
            >
              Yes
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default Archive;
